import { createSlice } from '@reduxjs/toolkit';

const initialStateValue = {
  loading: false,
  ticketsList: null,
  myTicketsList: null,
  assignedToMeTicketsList: null,
  myGroupTicketsList: null,
  ticketDetail: null,
  ticketPriorityList: null,
  ticketStatusList: null,
  replyingTo: null,
  archiveTicketList: null,
  referedByMeTicketList: null,
};

export const ticketSlice = createSlice({
  name: 'ticket',
  initialState: initialStateValue,
  reducers: {
    setTicketLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setTicketList: (state, { payload }) => {
      state.ticketsList = payload;
    },
    setMyTicketsList: (state, { payload }) => {
      state.myTicketsList = payload;
    },
    setAssignedToMeTicketsList: (state, { payload }) => {
      state.assignedToMeTicketsList = payload;
    },
    setMyGroupTicketsList: (state, { payload }) => {
      state.myGroupTicketsList = payload;
    },
    setTicketResetLists: (state) => {
      state.myTicketsList = null;
      state.assignedToMeTicketsList = null;
      state.myGroupTicketsList = null;
      state.referedByMeTicketList = null;
      state.archiveTicketList = null;
    },
    setTicketDetail: (state, { payload }) => {
      state.ticketDetail = payload;
    },
    setTicketPriorityList: (state, { payload }) => {
      state.ticketPriorityList = payload;
    },
    setTicketStatusList: (state, { payload }) => {
      state.ticketStatusList = payload;
    },
    setTicketReplyingTo: (state, { payload }) => {
      state.replyingTo = payload;
    },
    setTicketReferedByMeList: (state, { payload }) => {
      state.referedByMeTicketList = payload;
    },
    setTicketArchiveList: (state, { payload }) => {
      state.archiveTicketList = payload;
    },
  },
});

export const {
  setTicketLoading,
  setTicketReplyingTo,
  setTicketList,
  setTicketDetail,
  setTicketPriorityList,
  setTicketStatusList,
  setMyTicketsList,
  setAssignedToMeTicketsList,
  setMyGroupTicketsList,
  setTicketResetLists,
  setTicketReferedByMeList,
  setTicketArchiveList,
} = ticketSlice.actions;

export default ticketSlice.reducer;
